// Public website (mongooseevm.com): terms, privacy, help and contact live there.
export const SITE_URL = ((import.meta.env.VITE_SITE_URL as string | undefined) ?? "https://mongooseevm.com").replace(/\/$/, "");
export const siteLink = (page: "terms" | "privacy" | "help" | "") => `${SITE_URL}/${page ? `${page}.html` : ""}`;
export const PRICE_PER_SEAT = 99;

/** Sign-up details kept across the sign-in that happens in the middle of creating an account. */
export interface PendingSignup {
  company: string;
  seats: number;
  acceptTerms: boolean;
}
const KEY = "mongoose.pendingSignup";
export const pendingSignup = {
  get: (): PendingSignup | null => {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    } catch {
      return null;
    }
  },
  set: (p: PendingSignup) => sessionStorage.setItem(KEY, JSON.stringify(p)),
  clear: () => sessionStorage.removeItem(KEY),
};
